import React from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Alert,
  Box,
} from "@mui/material";
import useApiEp from "../hooks/useApiEp";
const CustomerIdsAutocomplete = ({
  value,
  onChange,
  label = "Customer ID",
  placeholder = "Select customer ID",
  required = false,
  disabled = false,
  size = "small",
  variant = "outlined",
  helperText,
  error: propError,
  enableSearch = true,
  allowCustomValues = false,
  maxOptions,
}) => {
  // API call inside the component
  const {
    data: customerIds,
    isLoading: isCsLoading,
    isError: isCsError,
    error: Cserror,
  } = useApiEp(`/api/customer-ids`);

  const getErrorMessage = () => {
    if (Cserror instanceof Error) {
      return Cserror.message;
    }
    if (typeof Cserror === "string") {
      return Cserror;
    }
    return "Failed to load customer IDs";
  };

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  const filterOptions = (options, state) => {
    if (!enableSearch) return options;

    const inputValue = state.inputValue.trim().toLowerCase();
    if (!inputValue) return options;

    return options.filter((option) =>
      option.toLowerCase().includes(inputValue)
    );
  };

  const getOptions = () => {
    let options = customerIds || [];
    if (maxOptions && options.length > maxOptions) {
      options = options.slice(0, maxOptions);
    }
    return options;
  };

  if (isCsError) {
    return (
      <Alert severity="error" sx={{ width: "100%" }}>
        {getErrorMessage()}
      </Alert>
    );
  }

  return (
    <Autocomplete
      value={value}
      onChange={handleChange}
      options={getOptions()}
      loading={isCsLoading}
      disabled={disabled || isCsLoading}
      size={size}
      filterOptions={enableSearch ? filterOptions : undefined}
      freeSolo={allowCustomValues}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant={variant}
          required={required}
          error={propError || isCsError}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isCsLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default CustomerIdsAutocomplete;
